import React from 'react';
import { Spin } from 'antd';

interface IProps {
    marginTop?: number;
}

export const PageLoader: React.FC<IProps> = (props: IProps) => {

    const { marginTop } = props;

    return (
        <div style={{ textAlign: "center", marginTop: !!marginTop ? marginTop.toString() : "150px" }}>
            <Spin size="large" style={{ verticalAlign: "middle" }} />
        </div>
    )

}
